import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { MedicationsFormModalValuesProps } from './medicationFormSchema';

/**
 * #688 R1-2: a new handed-over Rx taking starts with the owner's address
 * when it is already on screen, and loses it again once the vet names
 * another recipient (their address is not the owner's). A saved taking, a
 * locked form or an address the vet typed is never touched.
 */
export function useRecipientAddressPrefill(
  active: boolean,
  ownerAddress?: string,
): void {
  const { watch, getValues, setValue } =
    useFormContext<MedicationsFormModalValuesProps>();
  const namesAnotherPerson = Boolean(watch('stockRecipientName')?.trim());

  useEffect(() => {
    if (!active || !ownerAddress) return;
    const address = getValues('stockRecipientAddress');
    if (!namesAnotherPerson && !address) {
      setValue('stockRecipientAddress', ownerAddress, { shouldDirty: true });
    } else if (namesAnotherPerson && address === ownerAddress) {
      setValue('stockRecipientAddress', '', { shouldDirty: true });
    }
  }, [active, ownerAddress, namesAnotherPerson, getValues, setValue]);
}
